import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import Select from "react-select";
import "../../assets/css/stepper.css";
import { getDefaultUserList } from "../../services/Users-services";
import { addRoleUser } from "../../services/Users-services";

import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import { createDivisionSectionSchedule } from "../../services/Academic-Services";

import { useGlobalState } from "../../services/hostelConst";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../services/redux/reducers/modalSlice";
const AddSectionSchedule = ({ navigate, refresh, params } = {}) => {
  const dispatch = useDispatch();

  const modal = useSelector((state) => state.modal);
  console.log("Params", params);

  const [formData, setFormData] = useState({
    // Site Info

    weekDay: { value: "", label: "", regionId: "", siteId: "" },
  });

  const weekDay = [
    { value: "MONDAY", label: "Monday" },
    { value: "TUESDAY", label: "Tuesday" },
    { value: "WEDNESDAY", label: "Wednesday" },
    { value: "THURSDAY", label: "Thursday" },
    { value: "FRIDAY", label: "Friday" },
    { value: "SATURDAY", label: "Saturday" },
    { value: "SUNDAY", label: "Sunday" },
  ];

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    return () => {};
  }, []);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.weekDay || !formData.weekDay.value) {
      newErrors.weekDay = "Week day is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    console.log(modal, "modal.data");
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      var data = {
        id: null,
        weekDay: formData.weekDay.value,
        sectionId: modal.data._ID,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
        regionId: modal.data._REGION,
        siteId: modal.data._SITE,
      };

      var res = await createDivisionSectionSchedule(data);
      if (res.status == "success") {
        callToast("success", "Success", "User Added  Successfully");
        await refresh();
        dispatch(closeModal());
      } else {
        dispatch(closeModal());
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
    }
  };

  return (
    <>
      <section className="">
        <div className="d-flex  justify-content-center ">
          <div className="w-100 m-3">
            <div className="d-flex h-100">
              <div className="w-100">
                <>
                  {
                    <>
                      <div className="row mb-3 m-4 me-2 ms-2">
                        <div className="col-md-12">
                          <label className="form-label">Week Day</label>
                          <Select
                            options={weekDay}
                            value={
                              formData.weekDay.label === ""
                                ? null
                                : formData.weekDay
                            }
                            onChange={(value) =>
                              handleChange(
                                "weekDay",
                                value == null
                                  ? {
                                      value: "",
                                      label: "",
                                      regionId: "",
                                      siteId: "",
                                    }
                                  : value
                              )
                            }
                            styles={selectStyle}
                            placeholder="Select Week day"
                            isSearchable
                            noOptionsMessage={() => {
                              return "No Week day Found";
                            }}
                            className="basic-single"
                            classNamePrefix="select"
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                          />
                          {errors.weekDay && (
                            <small className="text-danger">
                              {errors.weekDay}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-end m-3 mb-0">
                        <Button
                          type="submit"
                          disabled={loading}
                          onClick={handleSubmit}
                        >
                          {loading ? (
                            <div
                              class="spinner-border text-light"
                              role="status"
                            >
                       
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    </>
                  }
                </>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddSectionSchedule;
